/** 
 * --- Accordion Module ---
 * Provides accordion functionality for sections of content.
 * Handles the expansion and collapse of accordion sections,
 * including initialisation and event binding.
 */

var accordion = function () {

    $('.accordion').each(function () {
        $(this).addClass('enabled');
        $(this).find('.accordion-title, .accordion-content').addClass('inactive');
        var hasActiveSection = $(this).find('.accordion-title.active').length > 0;
        if (hasActiveSection) {
            $(this).find('.accordion-title.active').next('.accordion-content').addClass('active').removeClass('inactive');
        }
    });

    $('.accordion-title').click(function () {
        var isActive = $(this).hasClass('active');
        if (!isActive) {
            $(this).next('.accordion-content').addClass('active').removeClass('inactive');
            $(this).addClass('active').removeClass('inactive');
        }
        else {
            $(this).next('.accordion-content').removeClass('active').addClass('inactive');
            $(this).removeClass('active').addClass('inactive');
        }
        return false;
    });
}

var accordionActivateItem = function (primaryAccordions) {
    // called in main JS initialisation to activate first accordion item on reminder banner if none are active.
    // used in 7 places in the site project.
    var firstItem = $(".c-reminder-banner").find(".c-accordion__item")
    if ($('.c-accordion-open').parent().parent().length > 0) {
        firstItem = $('.c-accordion-open').parent().parent();
    }
    primaryAccordions.setActiveAccordion(firstItem.first(), false)
}

var dashboardAccordions = function () {
    // called in main JS initialisation for dashboard pages to initialise primary and sub accordions.
    // used in 1 place in the Dll, 21 places in the site project. 

    var primaryAccordions = new logicjs.accordions({
        container: ".c-accordion",
        accordionsClass: ".c-accordion__item",
        accordionCtrlTarget: ".c-accordion__toggle-ctrl",
        hiddenClass: "hidden",
        accordionView: ".c-accordion__view",
        loadActiveClass: "c-accordion--open",
        toggleAccordions: true,
        loadingClass: "loading"
    });
    var subAccordions = new logicjs.accordions({
        container: ".c-sub-accordion",
        accordionsClass: ".c-sub-accordion__item",
        accordionCtrlTarget: ".c-sub-accordion__toggle-ctrl",
        hiddenClass: "hidden",
        accordionView: ".c-sub-accordion__view",
        loadActiveClass: "c-sub-accordion--open",
        loadingClass: "loading",
        toggleAccordions: false,
        parentAccordionView: primaryAccordions.accordionView
    });

    return primaryAccordions
};

var pageAccordions = function () {
    // used in: dashboard/online-course/content-page.aspx to initialise accordions

    var generalAccordion = new logicjs.accordions({
        container: ".c-general-accordion",
        accordionsClass: ".c-general-accordion__item",
        accordionCtrlTarget: ".c-general-accordion__toggle-ctrl",
        hiddenClass: "hidden",
        accordionView: ".c-general-accordion__view",
        loadActiveClass: "initially-opened",
        toggleAccordions: false,
        disableAccordionClick: false,
        loadingClass: "loading",
        scrollToView: false,
        scrollUnderClassList: ["outer-wrapper-preheader", "outer-wrapper-header"],
        scrollTransitionDelay: 220,
        urlHashLoad: true,
        urlHashAttributeSelector: "data-id"
    });
};